import {Injectable} from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  RouterOutlet,
  ActivatedRoute
} from '@angular/router';

import {CustomAuthService} from '../services/custom-auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authSrv: CustomAuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot) {
    if (!this.authSrv.getToken()) {
      this.authSrv.checkForAutoLogin();
    }
    if (this.authSrv.isUserLoggedIn()) {
      return true;
    } else {
      sessionStorage.setItem('redirectUrl', state.url);
      if(this.authSrv.isGetNewToken()) {
        this.authSrv.login();
      }else
        this.router.navigate(['/home']);

      return false;
    }
  }
}

